import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { styled } from "@mui/material/styles";

interface ILogoProps extends SvgIconProps {
  variant?: "default" | "black";
}

interface IIconsMap {
  default: {
    viewBox: string;
    icon: JSX.Element;
    [k: string]: any;
  };
  black: {
    viewBox: string;
    icon: JSX.Element;
    [k: string]: any;
  };
}

const iconsMap: IIconsMap = {
  default: {
    viewBox: "143 28",
    icon: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H7.71789C8.7423 0 9.72475 0.406974 10.4491 1.13135C11.1735 1.85572 11.5804 2.83817 11.5804 3.86259V10.5895H8.2025V5.30924H3.37792V10.5895H8.2025L11.5804 14.0108V24.1374C11.5804 25.1618 11.1735 26.1443 10.4491 26.8687C9.72475 27.593 8.7423 28 7.71789 28H0V0ZM8.2025 22.6763V15.9132H3.37792V22.6763H8.2025ZM31.8553 1.45435e-05H28.4773V5.30923H31.8553V1.45435e-05ZM128.94 5.30923L129.403 1.45435e-05H124.579L124.108 5.30923H128.94ZM120.166 1.45435e-05L120.542 5.30923H117.157L116.788 1.45435e-05H120.166ZM22.2061 28H25.584V19.3128L22.2061 15.9277L25.5841 15.9277V3.86259C25.5841 3.35535 25.4841 2.85308 25.29 2.38446C25.0959 1.91583 24.8114 1.49002 24.4527 1.13135C24.094 0.772676 23.6682 0.488143 23.1996 0.294031C22.731 0.0999185 22.2287 2.48012e-06 21.7215 2.48012e-06H13.9963V28H17.3743V15.9277L22.2061 15.9277V28ZM72.8896 1.45435e-05H62.7558V5.30923H72.8896V1.45435e-05ZM114.886 3.86259V5.30924H103.298V3.86259C103.298 3.35535 103.398 2.85308 103.592 2.38446C103.786 1.91583 104.071 1.49002 104.43 1.13135C104.788 0.772676 105.214 0.488143 105.683 0.294031C106.151 0.0999185 106.654 2.48012e-06 107.161 2.48012e-06H111.023C111.531 2.48012e-06 112.033 0.0999185 112.502 0.294031C112.97 0.488143 113.396 0.772676 113.755 1.13135C114.113 1.49002 114.398 1.91583 114.592 2.38446C114.786 2.85308 114.886 3.35535 114.886 3.86259ZM86.886 5.30924V2.48012e-06H79.1681C78.6609 2.48012e-06 78.1586 0.0999185 77.69 0.294031C77.2213 0.488143 76.7955 0.772676 76.4369 1.13135C76.0782 1.49002 75.7937 1.91583 75.5996 2.38446C75.4055 2.85308 75.3056 3.35535 75.3056 3.86259V5.30924H86.886ZM100.89 3.86259V5.30924H89.3019V2.48012e-06H97.027C97.5343 2.48012e-06 98.0366 0.0999185 98.5052 0.294031C98.9738 0.488143 99.3996 0.772676 99.7583 1.13135C100.117 1.49002 100.401 1.91583 100.596 2.38446C100.79 2.85308 100.89 3.35535 100.89 3.86259ZM52.1301 1.45435e-05H48.7522V5.30923H52.1301V1.45435e-05ZM56.962 1.45435e-05H60.3399V5.30923H56.962V1.45435e-05ZM46.3363 5.30924V2.48012e-06H38.6184C38.1112 2.48012e-06 37.6089 0.0999185 37.1403 0.294031C36.6716 0.488143 36.2458 0.772676 35.8872 1.13135C35.5285 1.49002 35.244 1.91583 35.0499 2.38446C34.8558 2.85308 34.7559 3.35535 34.7559 3.86259V5.30924H46.3363ZM66.1337 28V9.35263L69.5117 9.5407V28H66.1337ZM111.508 11.8915V22.6908H106.683V11.6239L103.298 11.4358V24.1374C103.298 25.1618 103.705 26.1443 104.43 26.8687C105.154 27.593 106.136 28 107.161 28H111.023C111.531 28 112.033 27.9001 112.502 27.706C112.97 27.5119 113.396 27.2273 113.755 26.8687C114.113 26.51 114.398 26.0842 114.592 25.6156C114.786 25.147 114.886 24.6447 114.886 24.1374V12.0796L111.508 11.8915ZM17.3743 10.6184H22.2061V5.30924H17.3743V10.6184ZM117.642 12.2387L118.749 28H122.126L121.034 12.4268L117.642 12.2387ZM100.89 28H97.5117V15.9277L100.89 19.3128V28ZM100.89 15.9277L97.5117 15.9277L92.6871 15.9277V28H89.3019V10.6474L100.89 11.2984V15.9277ZM142.893 1.45435e-05H131.306V5.30923H142.893V1.45435e-05ZM140.477 15.9277H134.683V22.6908H142.886V28H131.306V13.0054L140.477 13.519V15.9277ZM123.479 12.5642L122.126 28H126.951L128.282 12.8318L123.479 12.5642ZM38.1338 7.78301L34.7559 7.59494V24.1374C34.7559 25.1618 35.1628 26.1443 35.8872 26.8687C36.6115 27.593 37.594 28 38.6184 28H46.3363V22.6908H38.1338V7.78301ZM28.4846 28V7.24052L31.8625 7.42858V28H28.4846ZM42.9656 19.3128L46.3435 22.6908V10.6185H42.9656V19.3128ZM75.3056 9.86619L78.6835 10.0543V22.6908H86.886V28H79.1681C78.1437 28 77.1612 27.593 76.4369 26.8687C75.7125 26.1443 75.3056 25.1618 75.3056 24.1374V9.86619ZM56.9619 8.83907V10.6185H52.1374V8.5642L48.7594 8.37614V28H52.1374V15.9277H56.9619V28H60.3399V9.02713L56.9619 8.83907ZM86.8932 22.6908L83.508 19.3128V10.6185H86.8932V22.6908Z"
        fill="#DEFF2B"
      />
    ),
  },
  black: {
    viewBox: "290 58",
    icon: (
      <>
        <g clipPath="url(#clip0_7485_55917)">
          <path
            d="M261.696 10.9977L262.635 0H252.843L251.889 10.9977H261.696Z"
            fill="#000F1B"
          />
          <path d="M64.6532 0H57.7974V10.9977H64.6532V0Z" fill="#000F1B" />
          <path
            d="M244.652 10.9977L243.888 0H237.033L237.781 10.9977H244.652Z"
            fill="#000F1B"
          />
          <path
            d="M45.0693 58.0001H51.9251V40.0053L45.0693 32.9932V58.0001Z"
            fill="#000F1B"
          />
          <path
            d="M15.6642 0H3.05176e-05V58H15.6642C17.7433 58 19.7373 57.157 21.2075 55.6565C22.6777 54.156 23.5036 52.121 23.5036 49.999V29.0225L16.6477 21.9354H6.85583V10.9977H16.6477V21.9354H23.5036V8.00107C23.5036 5.87907 22.6777 3.84399 21.2075 2.3435C19.7373 0.843019 17.7433 0 15.6642 0ZM16.6477 32.9631V46.9724H6.85583V32.9631H16.6477Z"
            fill="#000F1B"
          />
          <path d="M147.936 0H127.369V10.9977H147.936V0Z" fill="#000F1B" />
          <path
            d="M233.171 10.9977V8.00107C233.171 6.95036 232.969 5.90996 232.575 4.93923C232.181 3.9685 231.603 3.08647 230.875 2.3435C230.147 1.60054 229.283 1.01115 228.332 0.609059C227.381 0.206969 226.362 0 225.332 0H217.493C216.463 0 215.444 0.206969 214.493 0.609059C213.542 1.01115 212.677 1.60054 211.949 2.3435C211.221 3.08647 210.644 3.9685 210.25 4.93923C209.856 5.90996 209.653 6.95036 209.653 8.00107V10.9977H233.171Z"
            fill="#000F1B"
          />
          <path
            d="M176.343 10.9977V0H160.679C159.649 0 158.63 0.206969 157.679 0.609059C156.728 1.01115 155.864 1.60054 155.136 2.3435C154.408 3.08647 153.83 3.9685 153.436 4.93923C153.042 5.90996 152.839 6.95036 152.839 8.00107V10.9977H176.343Z"
            fill="#000F1B"
          />
          <path
            d="M204.765 10.9977V8.00107C204.765 6.95036 204.562 5.90996 204.168 4.93923C203.774 3.9685 203.196 3.08647 202.468 2.3435C201.741 1.60054 200.876 1.01115 199.925 0.609059C198.974 0.206969 197.955 0 196.925 0H181.246V10.9977H204.765Z"
            fill="#000F1B"
          />
          <path d="M105.803 0H98.9471V10.9977H105.803V0Z" fill="#000F1B" />
          <path d="M122.465 0H115.609V10.9977H122.465V0Z" fill="#000F1B" />
          <path
            d="M94.0438 10.9977V0H78.3796C77.3501 0 76.3307 0.206969 75.3796 0.609059C74.4285 1.01115 73.5642 1.60054 72.8363 2.3435C72.1083 3.08647 71.5309 3.9685 71.137 4.93923C70.743 5.90996 70.5402 6.95036 70.5402 8.00107V10.9977H94.0438Z"
            fill="#000F1B"
          />
          <path
            d="M134.224 19.373V57.9997H141.08V19.7626L134.224 19.373Z"
            fill="#000F1B"
          />
          <path
            d="M226.316 24.6324V47.0023H216.524V24.0781L209.653 23.6885V49.999C209.653 52.121 210.479 54.1561 211.949 55.6566C213.42 57.157 215.414 58.0001 217.493 58.0001H225.332C226.362 58.0001 227.381 57.7931 228.332 57.391C229.283 56.9889 230.147 56.3995 230.875 55.6566C231.603 54.9136 232.181 54.0317 232.575 53.0609C232.969 52.0902 233.171 51.0497 233.171 49.999V25.022L226.316 24.6324Z"
            fill="#000F1B"
          />
          <path
            d="M44.0857 0H28.4069V58H35.2627V32.9931H51.9252V8.00107C51.9252 6.95036 51.7224 5.90996 51.3284 4.93923C50.9345 3.9685 50.357 3.08647 49.629 2.3435C48.9011 1.60054 48.0369 1.01115 47.0857 0.609059C46.1346 0.206969 45.1152 0 44.0857 0ZM45.0693 21.9953H35.2627V10.9977H45.0693V21.9953Z"
            fill="#000F1B"
          />
          <path
            d="M238.765 25.3516L241.011 58H247.867L245.65 25.7411L238.765 25.3516Z"
            fill="#000F1B"
          />
          <path
            d="M197.909 58.0001H204.765V40.0053L197.909 32.9932V58.0001Z"
            fill="#000F1B"
          />
          <path d="M290.015 0H266.496V10.9977H290.015V0Z" fill="#000F1B" />
          <path
            d="M273.352 32.9927H285.111V28.0033L266.496 26.9395V57.9996H290V47.002H273.352V32.9927Z"
            fill="#000F1B"
          />
          <path
            d="M250.612 26.0254L247.867 57.9996H257.659L260.36 26.5798L250.612 26.0254Z"
            fill="#000F1B"
          />
          <path
            d="M181.246 22.0557V58.0004H188.117V32.9934H204.765V23.4042L181.246 22.0557Z"
            fill="#000F1B"
          />
          <path
            d="M77.396 16.122L70.5402 15.7324V49.999C70.5402 52.121 71.3661 54.1561 72.8363 55.6566C74.3065 57.1571 76.3004 58.0001 78.3796 58.0001H94.0438V47.0024H77.396V16.122Z"
            fill="#000F1B"
          />
          <path
            d="M57.8121 14.998V57.9999H64.6679V15.3876L57.8121 14.998Z"
            fill="#000F1B"
          />
          <path
            d="M87.2026 40.0049L94.0584 47.0021V21.9951H87.2026V40.0049Z"
            fill="#000F1B"
          />
          <path
            d="M159.695 20.8271L152.839 20.4375V49.9993C152.839 52.1213 153.665 54.1564 155.136 55.6569C156.606 57.1574 158.6 58.0004 160.679 58.0004H176.343V47.0027H159.695V20.8271Z"
            fill="#000F1B"
          />
          <path
            d="M115.609 18.3095V21.9954H105.818V17.7401L98.9617 17.3506V58H105.818V32.9931H115.609V58H122.465V18.6991L115.609 18.3095Z"
            fill="#000F1B"
          />
          <path
            d="M169.487 40.0049L176.358 47.0021V21.9951H169.487V40.0049Z"
            fill="#000F1B"
          />
        </g>
        <defs>
          <clipPath id="clip0_7485_55917">
            <rect width="290" height="58" fill="white" />
          </clipPath>
        </defs>
      </>
    ),
  },
};

const SvgIconStyled = styled(SvgIcon)(({ theme }) => ({
  width: "auto",
}));

export function LogoIcon(props: ILogoProps) {
  const { variant, ...restProps } = props;
  const currentVariant = iconsMap[variant || "default"];
  const viewBox = currentVariant?.viewBox;
  const icon = currentVariant?.icon;

  return (
    <SvgIconStyled {...restProps} viewBox={`0 0 ${viewBox}`}>
      {icon}
    </SvgIconStyled>
  );
}
